import Resources from '../Resources.vue'

export default [
    {
        path: '/resources', 
        name: '/resources', 
        meta: { layout: 'mystagit' },
        component: Resources,
    }
]